// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1gyr6","rightAdornment":"Header_rightAdornment__YBRjj"};